import axios from "axios";
import {METHOD_TYPE, GRAPHQL_ENDPOINT} from "@/common/utils/constants";

export function fetchUsers(criteria) {

	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
  					getUsers(criteriaFilter: {
  								${criteria.pageable ? `pageable: {page: ${criteria.pageable.page}, size: ${criteria.pageable.size}}` : ''}
									${criteria.userId ? `userId: ${criteria.userId}` : ''}
									${criteria.text ? `text: "${criteria.text}"` : ''}
									${criteria.status ? `status: ${criteria.status}` : ''}
									${criteria.permissionIds ? `permissionIds: [${criteria.permissionIds}]` : ''}
									${criteria.sort ? `sort: [{ by: "${criteria.sort[0].by}", order: "${criteria.sort[0].order}"}, { by: "${criteria.sort[1].by}", order: "${criteria.sort[1].order}"}]` : ''}
									${criteria.isExactlyOneExpected ? `isExactlyOneExpected: ${criteria.isExactlyOneExpected}` : `isExactlyOneExpected: false`}
									isGuestUser: true
  					}) {
    					id,
    					fullName,
    					email,
    					company,
    					jobTitle,
    					createdDate,
    					status,
    					lastLoginDate
  					}
					}`
		}
	})
		.then(response => {
			return response.data.data.getUsers
		});
}

export function fetchActiveNewsLetters() {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
  					getActiveNewsletters {
    					id,
    					title,
    					topic,
    					platform,
    					redirectUrl,
    					message,
    					redirectionButtonText,
    					displayOrder
  					}
					}`
		}
	})
		.then(response => {
			return response.data.data.getActiveNewsletters
		});
}

export function fetchAllServiceLines() {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getServiceLines {
							id,
							name,
							orderNumber,
							translations {
									id,
									language {
											name
									},
									name
							},
							objectUrl,
							objectKey,
							subServiceLines {
									id,
									name,
									translations {
											name,
											language {
													name
											}
									},
									serviceLine {
											id
									}
							}
					}
			}`
		}
	})
		.then(response => {
			return response.data.data.getServiceLines
		});
}

export function fetchAllGlobalOwners() {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
    			getAllGlobalOwners{
						id,
						fullName,
						email
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getAllGlobalOwners
		});
}

export function fetchAllEditors() {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
    			getAllEditors{
						id,
						fullName,
						email
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getAllEditors
		});
}

export function fetchAllCompetitors() {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
    			getAllCompetitors{
						id,
						name
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getAllCompetitors
		});
}

export function fetchAllMainClientPersonas() {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
    			 getAllMainClientPersonas{
						id,
						jobDescription
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getAllMainClientPersonas
		});
}

export function fetchAllLifecycles() {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
    			 getAllLifecycles{
						id,
						name
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getAllLifecycles
		});
}

export function fetchAllTechPractices() {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getTechPractices {
							id,
							name,
							translations {
									id,
									language {
											name
									},
									name
							},
							orderNumber,
							objectUrl,
							objectKey,
							subTechPractices {
									id,
									name,
									translations {
											id,
											language {
													name
											},
											name
									}
							}
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getTechPractices
		});
}

export function fetchAllIndustries() {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
    			getIndustries {
    				id,
        		name,
				 		isKeyIndustry,
   					orderNumber,
   					slug,
    				objectKey,
    				translations {
            	language {
                id,
                name
            	},
            	name
        		},
   					subIndustries {
            	id,
            	name,
            	translations {
								language {
									id,
									name
								},
								name
							}
        		}
    			}
				}`
		}
	})
		.then(response => {
			return response.data.data.getIndustries
		});
}

export function fetchIndustryById(id) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
						getIndustryById(industryId: ${id}) {
								id,
								name,
								translations {
										name,
										language {
												name
										}
								},
								subIndustries {
									id,
									translations {
										language {
											name
										},
										name
									}
								}
						}
				}`
		}
	})
		.then(response => {
			return response.data.data.getIndustryById
		});
}

export function fetchIndustriesByIds(industryIds) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
						getAllIndustriesByIds(industryIds: [${industryIds}]) {
								id,
								name,
								translations {
										name,
										language {
												name
										}
								},
								subIndustries {
									id,
									translations {
										language {
											name
										},
										name
									}
								}
						}
				}`
		}
	})
		.then(response => {
			return response.data.data.getAllIndustriesByIds
		});
}

export function fetchAllIndustriesByIsKeyIndustry() {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
    			getIndustriesByIsKeyIndustry(isKeyIndustry: true) {
        		id,
   					slug,
    				translations {
    				  language {
               name
            	},
            	name
        		},
        		subIndustries {
        			id
        		}
    			}
				}`
		}
	})
		.then(response => {
			return response.data.data.getIndustriesByIsKeyIndustry
		});
}

export function fetchAllDeliveryCountries() {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
    			getAllDeliveryCountries {
    				id
    				name,
    				gopUrlLink
    			}
				}`
		}
	})
		.then(response => {
			return response.data.data.getAllDeliveryCountries
		});
}

export function fetchCountriesByIsModisCountry(isAkkodisCountry) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
    			getCountriesByIsModisCountry(isDeliveryCountry: ${isAkkodisCountry}) {
    				id
    				name
    			}
				}`
		}
	})
		.then(response => {
			return response.data.data.getCountriesByIsModisCountry
		});
}

export function fetchProjects() {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getProjectsForGopSubmissionForm{
    				id,
            translations{
              language{
                name
              }
              referenceTitle
            }
            management{
              datePublish
            }
  				}
				}`
		}
	})
		.then(response => {
			return response.data.data.getProjectsForGopSubmissionForm
		});
}

export function fetchCountries(getIsDeliveryCountry = false) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
    			getCountries {
    				id,
    				name,
    				${getIsDeliveryCountry ? ', isDeliveryCountry' : ''}
    			}
				}`
		}
	})
		.then(response => {
			return response.data.data.getCountries
		});
}

export function fetchQualificationAttributes(type, drcStatuses, gopStatuses) {
	let params;
	if (drcStatuses) {
		params = `type: ${type}, statuses: [${drcStatuses}]`
	} else {
		params = `type: ${type}, gopApprovalStatuses: [${gopStatuses}]`;
	}

	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getQualificationAttributesByTypeAndStatuses(${params}) {
							id,
							name,
							type,
							approvalStatus,
							gopApprovalStatus,
							oldName
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getQualificationAttributesByTypeAndStatuses;
		});
}

export function fetchGopQualificationAttributes(type, statuses) {

	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getQualificationAttributesByTypeAndStatuses(type: ${type}, gopApprovalStatuses: [${statuses}]) {
							id,
							name,
							type,
							gopApprovalStatus
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getQualificationAttributesByTypeAndStatuses;
		});
}

export function getPublishedOfferById(id) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getPublishedOfferById(offerId: ${id}) {
						id,
						creatorId,
						videoLinks {
							name
							url
						}
						submission {
							id,
							languageId,
							creationDateTime,
							publishedDateTime
						},
						relatedSectors {
							images {
									id
									url
									key
									type
							}
							id
							type
							isActive
							isPublished
							category
							translations {
                id
                languageId
                title
                description
            	}
						}
						industryRelations {
							id,
							industryId,
							subIndustryRelations {
								id,
								subIndustryId
							}
						},
						references {
							id,
							description,
							url
						},
						translations {
							id,
							languageId,
							title,
							description,
							biggestMarketConclusion,
							keyMarketDrivers,
							marketOpportunities,
							keyHighlights,
							additionalNotes,
							clientNeeds,
							clientBenefits,
							tips
						},
						images {
							id,
							url,
							key,
							type
						},
						files {
							id,
							url,
							key,
							type
						},
						countryRelations {
							id,
							countryId,
							type
						},
						serviceLineRelations {
							id,
							serviceLineId,
							subServiceLineRelations {
								id,
								subServiceLineId
							}
						},
						techPracticeRelations {
							id,
							techPracticeId,
							subTechPracticeRelations {
								id,
								subTechPracticeId
							}
						},
						qualificationAttributeRelations {
							id,
							qualificationAttributeId
						},
						globalOwners {
							id,
							fullName,
							email
						},
						mainClientPersonas {
							id,
							jobDescription
						},
						lifecycles {
							id,
							name
						},
						competitors {
							id,
							name
						}
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.getPublishedOfferById
		});
}

export function getCountriesByIds(countryIds) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
						getAllCountriesByIds(countryIds: [${countryIds}]) {
								id,
								name
						}
				}`
		}
	})
		.then(response => {
			return response.data.data.getAllCountriesByIds
		});
}

export function getAllOffers() {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query: `{
					searchOfferByCriteria(criteriaFilter:{isManagement:false}){
						id,
						type,
						countryRelations{
							countryId,
							type
						}
						translations{
							languageId,
							title
						},
						isActive,
						isPublished
					}
				}`
		}
	}).then(response => {
		return response.data.data.searchOfferByCriteria;
	})
}

export function getGlobalOffers() {
		return axios({
			url: GRAPHQL_ENDPOINT,
			method: METHOD_TYPE.POST,
			data: {
				query: `{
					searchOfferByCriteria(criteriaFilter:{types:[GLOBAL], isManagement:false, pageable: { page: 0, size: 999999 }}){
						id,
						type,
						translations{
							languageId,
							title
						},
						localizedOffers{
							id,
							countryRelations{
								countryId,
								type
							}
						},
						globalOffers{
							id
						}
						isActive,
    				isPublished
					}
				}`
			}
		}).then(response => {
			return response.data.data.searchOfferByCriteria;
		})
}

export function getGlobalSectors() {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query: `{
					searchSectorByCriteria(criteriaFilter:{types:[GLOBAL], isManagement:false, pageable: { page: 0, size: 999999 }}){
						id,
						type,
						translations{
							languageId,
							title
						},
						localizedSectors{
							id,
							countryRelations{
								countryId,
								type
							}
						},
						globalSectors{
							id
						}
						isActive,
    				isPublished
					}
				}`
		}
	}).then(response => {
		return response.data.data.searchSectorByCriteria;
	})
}
export function getAllSectors() {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query: `{
					searchSectorByCriteria(criteriaFilter:{isManagement:false}){
						id,
						type,
						countryRelations{
							countryId,
							type
						}
						translations{
							languageId,
							title
						},
						isActive,
						isPublished
					}
				}`
		}
	}).then(response => {
		return response.data.data.searchSectorByCriteria;
	})
}

export function getProjectMainImageByProjectId(projectId) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
						getProjectMainImageById(projectId: ${projectId}) {
								id,
								objectUrl
						}
				 }`
		}
	})
		.then(response => {
			return response.data.data.getProjectMainImageById
		});
}

export function getProjectPublishDateById(id) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`
				  {
						getPublishedProjectById(id: ${id}) {
						  id,
					  	management {
								datePublish,
								dateSubmitted
					  	}
						}
				  }
				`
		}
	})
		.then(response => {
			return response.data.data.getPublishedProjectById;
		});
}

export function getQualificationAttributesByIds(criteria) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
						searchQualificationAttributes(
							criteria: {
									${criteria.isExactlyOneExpected ? `isExactlyOneExpected: ${criteria.isExactlyOneExpected}` : ''}
									${criteria.hasSubmissions ? `hasSubmissions: ${criteria.hasSubmissions}` : ''}
									${criteria.approvalStatuses ? `approvalStatuses: [${criteria.approvalStatuses}]` : ''}
									${criteria.gopApprovalStatuses ? `gopApprovalStatuses: [${criteria.gopApprovalStatuses}]` : ''}
									${criteria.type ? `type: ${criteria.type}` : ''}
									${criteria.pageable ? `pageable: { page: ${criteria.pageable.page}, size: ${criteria.pageable.size}` : 'pageable: { page: 0, size: 100000000}'}
									${criteria.sort ? `sort: { by: ${criteria.sort.by}, order: ${criteria.sort.order} }` : ''}
									${criteria.name ? `name: ${criteria.name}` : ''}
									${criteria.text ? `text: ${criteria.text}` : ''}
									${criteria.ids ? `ids: [${criteria.ids}]` : ''}
							}
					) {
							id,
							name,
							approvalStatus,
							type
					}
				}`
		}
	})
		.then(response => {
			return response.data.data.searchQualificationAttributes;
		});
}

export function fetchServiceLinesByIds(serviceLineIds) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`
				  {
						getServiceLinesByIds(serviceIds: [${serviceLineIds}]) {
								id,
								name,
								translations {
										language {
												name
										},
										name
								},
								subServiceLines {
										id,
										translations {
												language {
														name
												},
												name
										}
								}
						}
				  }
				`
		}
	})
		.then(response => {
			return response.data.data.getServiceLinesByIds;
		});
}

export function fetchTechPracticesByIds(techPracticeIds) {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`
				  {
						getTechPracticesByIds(techPracticesIds: [${techPracticeIds}]) {
								id,
								name,
								translations {
										language {
												name
										},
										name
								},
								subTechPractices {
										id,
										name,
										translations {
												language {
														name
												},
												name
										}
								}
						}
				  }
				`
		}
	})
		.then(response => {
			return response.data.data.getTechPracticesByIds;
		});
}

export function fetchProjectsForPromotion() {
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query:
				`{
					getProjectsForGopSubmissionForm{
    				id,
            translations{
            	referenceTitle
              language{
                name
              }
            }
            owner {
							id
						}
  				}
				}`
		}
	})
		.then(response => {
			return response.data.data.getProjectsForGopSubmissionForm
		});
}

export function getOffersForRecognitions(){
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query: `{
					searchOfferByCriteria(criteriaFilter:{isManagement:false}){
						id,
						translations{
							languageId,
							title
						}
					}
				}`
		}
	}).then(response => {
		return response.data.data.searchOfferByCriteria;
	})
}

export function getSectorsForRecognitions(){
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query: `{
					searchSectorByCriteria(criteriaFilter:{isManagement:false}){
						id,
						translations{
							languageId,
							title
						},
						category
					}
				}`
		}
	}).then(response => {
		return response.data.data.searchSectorByCriteria;
	})
}

export function getAnalysts(){
	return axios({
		url: GRAPHQL_ENDPOINT,
		method: METHOD_TYPE.POST,
		data: {
			query: `{
					getAllAnalysts{
						id,
						name
					}
				}`
		}
	}).then(response => {
		return response.data.data.getAllAnalysts;
	})
}
